var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.6667H22.515M4.5 21.3333L12 14.6667C13.392 13.476 15.108 13.476 16.5 14.6667L24 21.3333M21 18.6667L22.5 17.3333C23.892 16.1427 25.608 16.1427 27 17.3333L31.5 21.3333M4.5 8C4.5 6.93913 4.97411 5.92172 5.81802 5.17157C6.66193 4.42143 7.80653 4 9 4H27C28.1935 4 29.3381 4.42143 30.182 5.17157C31.0259 5.92172 31.5 6.93913 31.5 8V24C31.5 25.0609 31.0259 26.0783 30.182 26.8284C29.3381 27.5786 28.1935 28 27 28H9C7.80653 28 6.66193 27.5786 5.81802 26.8284C4.97411 26.0783 4.5 25.0609 4.5 24V8Z",
    stroke: "#354052",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.4089f55a0949743f3c3650685f2acae8.svg";
export { ForwardRef as ReactComponent };